import { Component, OnInit, SkipSelf } from '@angular/core';
import { DynamicFormService, FORM_SERVICE_PROVIDER_TOKEN } from '@ntap/common';
import {
  ItemView,
  ItemViewProviderDirective,
  NtapGlobalConstants,
  Util
} from '@ntap/core';
import { first, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-kratka-povijest-promjena',
  templateUrl: './kratka-povijest-promjena.component.html',
  styleUrls: ['./kratka-povijest-promjena.component.scss'],
  providers: [
    DynamicFormService,
    { provide: FORM_SERVICE_PROVIDER_TOKEN, useExisting: DynamicFormService }, // ovdje nam treba zaseban token jer je povijest svoj zaseban ekran
    { provide: ItemViewProviderDirective, useClass: ItemViewProviderDirective }
  ]
})
export class KratkaPovijestPromjenaComponent implements OnInit {
  public item$: Observable<any>;

  constructor(
    @SkipSelf()
    protected parentItemViewProvider: ItemViewProviderDirective<ItemView>,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {}
  ngOnInit(): void {
    this.item$ = this.parentItemViewProvider.item$.pipe(
      // filter((parentItem: any) => parentItem[Util.getFullAttrName(parentItem[NtapGlobalConstants.ATTR_$itemType], 'status')] !== 'T'), TODO filtrirati da se ni ne pokazuje dok nije spremljena prvi puta
      first(),
      tap((parentItem: any) => {
        this.itemViewProvider.viewName = 'kratka_povijest_promjena';
        const childToParentIdAttrName = Util.getFullAttrName(
          'earhiv~povijest_izmjena',
          'entitet_id'
        );
        const parentIdAttrName = Util.getFullAttrName(
          parentItem[NtapGlobalConstants.ATTR_$itemType],
          NtapGlobalConstants.ATTR_id
        );
        this.itemViewProvider.viewState = {
          [childToParentIdAttrName]: parentItem[parentIdAttrName],
          [NtapGlobalConstants.ATTR_$itemType]:
            parentItem[NtapGlobalConstants.ATTR_$itemType]
        };
      })
    );
  }
}
